import { APICore } from "./apiCore";

const api = new APICore();

// Get Rentals Report
function getRentalsReportApi(
  type: string,
  startDate?: any,
  endDate?: any,
  packageType?: any,
  rentalStatus?: any,
  paymentStatus?: any,
  locationId?: any,
  corporateId?: any,
  page?: number,
  limit?: number,
  userId?: any,
  show_deleted?: boolean
) {
  const baseUrl = "/web/rental-report";

  let params: any = {};
  if (type) params.type = type;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (packageType) params.packageType = packageType;
  if (rentalStatus) params.rentalStatus = rentalStatus;
  if (paymentStatus) params.paymentStatus = paymentStatus;
  if (locationId) params.locationId = locationId;
  if (corporateId) params.corporateId = corporateId;
  if (page) params.page = page;
  if (limit) params.limit = limit;
  if (userId) params.user = userId;
  if (show_deleted !== undefined) params.show_deleted = show_deleted;

  return api.get(baseUrl, params);
}

// Get Revenue Report
function getRevenueReportApi(
  type: string,
  startDate?: any,
  endDate?: any,
  packageType?: any,
  locationId?: any,
  corporateId?: any,
  page?: number,
  limit?: number,
  userId?: any,
  show_deleted?: boolean
) {
  const baseUrl = "/web/revenue-report";

  let params: any = {};
  if (type) params.type = type;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (packageType) params.packageType = packageType;
  if (locationId) params.locationId = locationId;
  if (corporateId) params.corporateId = corporateId;
  if (page) params.page = page;
  if (limit) params.limit = limit;
  if (userId) params.user = userId;
  if (show_deleted !== undefined) params.show_deleted = show_deleted;

  return api.get(baseUrl, params);
}

// Get Devices Report
function getLocationsReportApi(type: string) {
  const baseUrl = "/web/location-report";

  return api.get(baseUrl, { type });
}

export { getRentalsReportApi, getLocationsReportApi, getRevenueReportApi };
